import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PaymentMethodDTO } from "@gymflow/types";
import { useTranslation } from "react-i18next";

import CustomTooltip from "../atoms/CustomTooltip";
import { EmptyDotBadge } from "../atoms/EmptyDotBadge";
import { PMAmexIcon } from "../atoms/icons/PMAmexIcon";
import { PMLinkIcon } from "../atoms/icons/PMLinkIcon";
import { PMMasterCardIcon } from "../atoms/icons/PMMasterCardIcon";
import { PMVisaIcon } from "../atoms/icons/PMVisaIcon";

export function PaymentMethodDetails({
  paymentMethod,
}: {
  paymentMethod?: PaymentMethodDTO;
}) {
  const { t } = useTranslation();
  if (!paymentMethod) {
    return (
      <div className="flex h-full w-full flex-row items-center justify-between"></div>
    );
  }
  if (paymentMethod.linkEmail) {
    return (
      <div className="flex h-full w-full flex-row items-center justify-between">
        <div className="dark:text-gray-0 text-sm font-bold text-gray-950">
          {paymentMethod.linkEmail}
        </div>
        <PMLinkIcon />
      </div>
    );
  }
  return (
    <div className="flex h-full w-full flex-row items-center justify-between">
      <div className="flex w-full flex-col items-start">
        <div className="dark:text-gray-0 text-sm font-bold text-gray-950">
          Card ending in {paymentMethod.last4Digits}
        </div>
        <div className="text-sm font-normal text-gray-500">
          Expiry {paymentMethod.expMonth}/{paymentMethod.expYear}
        </div>
      </div>
      {paymentMethod.status === "ACTIVE" &&
        paymentMethod.cardBrand in brandToIconMap &&
        brandToIconMap[paymentMethod.cardBrand as keyof typeof brandToIconMap]}
      {paymentMethod.status === "PENDING" && (
        <EmptyDotBadge size="small" intent="warning">
          {t("common.paymentMethods.pending")}
        </EmptyDotBadge>
      )}
      {paymentMethod.status === "INVALID" && (
        <div className="flex flex-row items-center gap-1">
          <CustomTooltip
            message={t(
              `common.paymentMethods.error_codes.${
                paymentMethod.invalidateReason
              }`,
            )}
          >
            <FontAwesomeIcon icon={faQuestionCircle} />
          </CustomTooltip>
          <EmptyDotBadge size="small" intent="error">
            {t("common.paymentMethods.invalid")}
          </EmptyDotBadge>
        </div>
      )}
    </div>
  );
}

const brandToIconMap = {
  visa: <PMVisaIcon />,
  amex: <PMAmexIcon />,
  mastercard: <PMMasterCardIcon />,
};
